import React, { Component } from 'react'

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
// import MobileSubHeader from '../../components/PageHeader/MobileSubHeader';
import SideBar from '../../components/SideBar/SideBar';
import ReactTooltip from "react-tooltip";
import { Link } from 'react-router-dom';
import moment from 'moment';
import MobileSubHeader from '../../components/PageHeader/MobileSubHeader';
import MemberProgress from '../DailyCheckIn/MemberProgress';
export class MobileCheckIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {

    const { t, icon, customizedVip, vip, claimBonus, start_day, end_day, handleVipLvl, currentVip } = this.props;
    const img = this.imageImport(require.context("../../assets/images/check-in", false, /\.(png|jpe?g|svg|webp)$/));    

    let imageLanguage = '';
    switch (this.props.currentUser.language_code) {
      case "zh-CN":
        imageLanguage = "-cn"
        break;
      case "ms":
        imageLanguage = "-ms"
        break;
      case "id":
        imageLanguage = "-id"
        break;
      default:
        imageLanguage = ""
        break;
    }

    return (
      <Auxiliary>
        <MobileSubHeader
          returnPage={this.props.prevPage ? this.props.prevPage : "/"}
          header={t("check_in.r7-daily-check-in")}
          style={{ justifyContent: "unset" }}
        />
        <section className='check-in-section'>
          <div className='m-container'>
            <div className='check-in-mobile-banner'>
              <img
                src={`${process.env.REACT_APP_S3_URL}/images/check-in/cny/mobile-banner/check-in${imageLanguage}.webp`}
                alt="R77 Daily Check-In Banner"
              />
            </div>

            <div className='check-in-header'>
              <img src={img['check-in-title-bg.webp']} alt='check-in background'/>
              <h2>{t('check_in.weekly-rewards')}</h2>
            </div>                

            <div className='check-in-main-container'>

              {/* Notice */}
              <div className='check-in-notice'>
                <img src={icon['bell.svg']} alt='bell'/>
                <p>{t('check_in.notice')}</p>                    
              </div>

              {/* VIPs */}      
              <div className='vips-container'>
                {customizedVip.map((vipVal, idx) => {
                    return (
                        <div className='d-flex flex-column'>
                          <div className={`vip-badge ${currentVip === vipVal.level ? "active" : ""}`} onClick={() => handleVipLvl(vipVal.level)}>
                              <img src={vip[`vip${vipVal.level}.webp`]} alt="vip-badge"/>
                              {t(`vip.vip-${vipVal.level}`)}                                  
                          </div>
                          {this.props.memberProgress.vipLevel === vipVal.level && (
                            <div className='badge-title'>
                              {t('vip.current-lvl')}
                            </div>
                          )}
                        </div>
                    );
                })}        
              </div>

              {/* Daily Check-In Rewards Based on VIP Select */}
              {/* Progress Bar */}
              <MemberProgress isCheckInPage={this.props.isCheckInPage} currentSelectVip={currentVip}/>            
            </div>

            <div className='section-header-gray'>
              <h2>{t('check_in.claim-check-in-bonus')}</h2>
              <p>{t('check_in.claim-check-in-bonus-notice')}</p>
            </div>
            
            <div>
              {this.props.currentSelectVipPrizesList.length > 0 &&
                <div className='claim-bonus-table'>                      
                  <table className='table'>
                    <thead>
                      <tr>
                        <th style={{ verticalAlign: 'top' }}>{t("check_in.daily-deposit-requirement")}</th>
                        <th style={{ verticalAlign: 'middle' }}><img src={img['cash.webp']} alt="bonus" style={{ width: '60px', height: 'auto' }} /></th>
                        <th style={{ verticalAlign: 'middle' }}><img src={img['coin.webp']} alt="coins" style={{ width: '60px', height: 'auto' }} /></th>
                        <th style={{ verticalAlign: 'middle' }}><img src={img['spin.webp']} alt="free-spins" style={{ width: '60px', height: 'auto' }} /></th>
                        <th style={{ verticalAlign: 'top' }}>{t("check_in.turnover-requirements")}</th>
                        <th style={{ verticalAlign: 'top' }}>{t("check_in.weekly-check-bonus")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.props.currentSelectVipPrizesList.map((item, index) => (
                          <tr key={index}>
                            <td className='number'>{item.required_deposit}</td>
                              <td className='number'>{item.reward_credit}</td>
                              <td className='number'>{item.reward_coin}</td>
                              <td className='number'>{item.reward_total_free_spin}</td>
                              <td className='number'>{item.turnover_multiplier}</td>
                              <td className='number'>{item.extra_reward_credit}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          
            <div className='info-center-section'>              
              <div className="row">
                <div className="info-content">    
                  <div className='section-header-gray'>
                    <h3>{t('check_in.rule-header')}</h3>                  
                  </div>                    
                  <div className="tab-content">
                    <div className="tab-pane fade show active info-tnc" id="tnc-main">                    
                      <ol className="tnc-custom-list">
                          <label>1</label>
                          <li>
                            {t('check_in.rule-1.1')} {""}
                            {this.state.start_day} 00:00:00am (GMT+08) {""}
                            {t('check_in.rule-1.2')} {""}
                            {this.state.end_day} 23:59:59pm (GMT+08) {""}
                            {t('check_in.rule-1.3')}
                          </li>
                        
                          <label>2</label>
                          <li>{t('check_in.rule-2')}</li>
                        
                          <label>3</label>
                          <li>{t('check_in.rule-3')}</li>
                        
                          <label>4</label>
                          <li>{t('check_in.rule-4')}</li>                              
                      
                          <label>5</label>
                          <li>{t('check_in.rule-5')}</li>                              
                        
                          <label>6</label>
                          <li>{t('check_in.rule-6')}</li>                              
                        
                          <label>7</label>
                          <li>{t('check_in.rule-7')}</li>                              
                      
                          <label>8</label>
                          <li>{t('check_in.rule-8')}</li>                              
                      
                          <label>9</label>
                          <li>{t('check_in.rule-9')}</li>                              
                        
                          <label>10</label>
                          <li>{t('check_in.rule-10')}</li>                              
                      
                          <label>11</label>
                          <li>{t('check_in.rule-11')}</li>                              
                      
                          <label>12</label>
                          <li>{t('check_in.rule-12')}</li>                              
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Auxiliary >

    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
  }
}

export default connect(mapStateToProps)(withNamespaces("translation")(MobileCheckIn));
